module.exports = __webpack_public_path__ + "img/icon_circle.bc612a41.png";